<svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13 1L7 7L1 1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke="#E5E5E5"/>
</svg>
